<template>
  <v-app :dark="true">
    <AutoLogout />
    <loading
      :active.sync="overlay"
      :is-full-page="true"
      :can-cancel="false"
      loader="bars"
      color="#264379"
      :opacity="0.35"
    ></loading>
    <v-overlay :value="overlay" :absolute="true"></v-overlay>
    <router-view></router-view>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="rightDrawer"
      hide-overlay
      fixed
    >

    </v-navigation-drawer>
    <!-- global snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="3000"
      app
      top
      centered
      :color="snackbar.color"
      class="kalan-snackbar"
      :class="`kalan-snackbar--${snackbar.color || 'default'}`"
    >
      <span class="kalan-snackbar__text">{{ snackbar.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <base-snackbar ref="messages"></base-snackbar>
  </v-app>
</template>

<script>
import NProgress from 'nprogress';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'
import AutoLogout from '@/components/AutoLogout.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Loading,
    AutoLogout,
  },
  data() {
    return {
      rightDrawer: false,
      overlay: false,
      snackbar: {
        show: false,
        text: '',
        color: '',
      },
    };
  },
  computed: {
    ...mapGetters('auth', ['getUser']),
    isMandoUnico() {
      return this.getUser?.attributes?.mando_unico;
    },
  },
  watch: {
    isMandoUnico: {
      immediate: true, // Ejecuta el watch al montar el componente
      handler(val) {
        document.documentElement.classList.remove('main-theme', 'mando-unico-theme');
        document.documentElement.classList.add(val ? 'mando-unico-theme' : 'main-theme');
      },
    },
  },
  methods: {
    loading(flag = true) {
      this.overlay = flag || false
      if (flag) {
        NProgress.start()
      } else {
        NProgress.done()
      }
    },
    showError(options) {
      const defaults = {
        top: options.bottom ? '' : true,
        right: options.left ? '' : true,
        color: 'error',
        ...options
      }
      this.$refs.messages.addMessage({ ...defaults, message: options })
    },
    showMessage(options) {
      const defaults = {
        top: options.bottom ? '' : true,
        center: true,
        color: 'secondary',
        ...options
      }
      this.$refs.messages.addMessage({ ...defaults, message: options })
    }
  },
  mounted() {
    // eslint-disable-next-line valid-typeof
    if (typeof window !== undefined && window.VMA === undefined) {
      window.VMA = this;
    }
  },
  created() {
    this.$on('SHOW_SNACKBAR', (e) => {
      this.snackbar = {
        show: true,
        text: e.text,
        color: e.color,
      };
    });
    this.$on('AUTH_FAIELD', () => {
      // En las rutas /auth/* (login) el feedback se muestra inline
      // sobre el boton "Acceder" — no duplicar con snackbar global.
      const route = this.$route;
      if (route && (route.name === 'login' || (route.path || '').startsWith('/auth'))) {
        return;
      }
      this.snackbar = {
        show: true,
        text: 'Sesión expirada. Vuelva a iniciar sesión.',
        color: 'error',
      };
    });
    this.$on('SERVER_ERROR', () => {
      this.snackbar = {
        show: true,
        text: 'Error del servidor. Intente de nuevo.',
        color: 'error',
      };
    });
  }
};
</script>

<style lang="css">
.v-application {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Global Kalan snackbar — dark glass aesthetic.
   Pisa el rojo brick / verde lime default de Vuetify. El color por evento
   sigue diferenciandose (error / success / secondary) pero con paleta
   alineada al tema cyan + dark navy. */
.kalan-snackbar .v-snack__wrapper {
  background: var(--kln-bg-overlay) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 12px !important;
  border: 1px solid var(--kln-border-dim);
  box-shadow:
    0 16px 48px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.02) inset !important;
  color: var(--kln-text) !important;
  min-width: 320px;
  padding: 0 4px 0 14px;
  position: relative;
  overflow: hidden;
}
.kalan-snackbar .v-snack__wrapper::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #1ec8d6;
}
.kalan-snackbar .v-snack__content {
  font-family: 'Inter', 'Public Sans', 'Roboto', system-ui, sans-serif !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  letter-spacing: 0.01em;
  padding: 14px 8px 14px 14px !important;
}
.kalan-snackbar__text {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.kalan-snackbar .v-snack__action .v-btn .v-icon {
  color: var(--kln-text-muted) !important;
  transition: color 0.15s;
}
.kalan-snackbar .v-snack__action .v-btn:hover .v-icon {
  color: var(--kln-text) !important;
}

/* Variantes por color */
.kalan-snackbar--error .v-snack__wrapper::before { background: #ff6b7a; }
.kalan-snackbar--error .v-snack__content::before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ff6b7a;
  box-shadow: 0 0 8px #ff6b7a;
  margin-right: 12px;
  vertical-align: middle;
}
.kalan-snackbar--success .v-snack__wrapper::before { background: #5fff9f; }
.kalan-snackbar--success .v-snack__content::before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #5fff9f;
  box-shadow: 0 0 8px #5fff9f;
  margin-right: 12px;
  vertical-align: middle;
}
.kalan-snackbar--secondary .v-snack__wrapper::before,
.kalan-snackbar--default .v-snack__wrapper::before { background: #1ec8d6; }
</style>
